exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#btnOptimisation{background:#9561e2;border:none;border-radius:15px;width:50%;display:flex;align-items:center;margin:auto}#btnOptimisation .btnText{flex:2}", ""]);

// exports
